<!-- @format -->

<template>
  <FlexCol gap-3 class="border-gray-200 divide-y">
    <!-- Cabeçalho -->
    <Flex justify-between items-center gap-3>
      <Flex center>
        <span> Código: </span>
        <h2 class="font-bold px-3">{{ item.id }}</h2>
      </Flex>
      <FlexCol>
        <span> Data Lançamento: </span>
        <h2 class="font-bold">{{ formatDate(item.requestedDate) ?? 'DD/MM/AA' }}</h2>
      </FlexCol>
    </Flex>

    <!-- Identificadores -->
    <Flex justify-between items-center gap-3 class="py-3">
      <FlexCol>
        <span>ID Obra</span>
        <h3 class="font-bold">{{ item.idConstructionProject ?? 'Não Informado' }}</h3>
      </FlexCol>
      <FlexCol>
        <span>Recurso</span>
        <h3 class="font-bold">{{ item.resourceName }}</h3>
      </FlexCol>
      <FlexCol>
        <span>Protocolo</span>
        <h3 class="font-bold">{{ formatProtocol(item.protocolo) }}</h3>
      </FlexCol>
    </Flex>

    <!-- Status Recebimento -->
    <Flex justify-between items-center gap-3 class="py-3">
      <FlexCol>
        <span>Status</span>
        <div class="py-2">
          <span
            class="py-1 px-2 border rounded-xl text-xs font-bold"
            :class="[item.statusName == 'Finalizada' ? 'bg-green-400 text-green-800' : 'border-yellow-200 bg-yellow-200']">
            {{ item.statusName }}
          </span>
        </div>
      </FlexCol>
      <FlexCol>
        <span>Responsável</span>
        <h3 :class="[item.userRequesterName ?? 'text-gray-400 font-bold italic']" class="font-bold">{{ item.userRequesterName ?? 'Pendente' }}</h3>
      </FlexCol>
      <FlexCol>
        <span>Data Conclusão</span>
        <h3 :class="[item.completedDate ?? 'text-gray-400 font-bold italic']" class="font-bold">{{ item.completedDate ? formatDate(item.completedDate) : 'Pendente' }}</h3>
      </FlexCol>
    </Flex>
    <!-- Tabela -->
    <Accordion title="Materiais">
      <TableFull :headers :items="item.items" v-model="tableControl" disableOrder ultradense>
        <template #withdraws-length="{ item, index }">
          <span v-if="item.withdraws && item.withdraws.length">{{ getWithdraws(item.withdraws, index) ?? 0 }}</span>
          <span v-else> 0 </span>
        </template>
      </TableFull>
    </Accordion>
  </FlexCol>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useStore } from 'vuex'
import { update } from '@/crud'
import moment from 'moment'

const { formatDate, formatDatetimeToTimezone, formatMoneyS, formatProtocol } = useFormat()

const item = defineModel('item', { type: Object })

const headers = ref([
  { title: 'Código', field: 'itemCode', disableOrder: true },
  { title: 'Item', field: 'itemName', disableOrder: true, itemClass: '!text-wrap' },
  { title: 'Estoque', disableOrder: true, field: 'totalAvaliable', disableOrder: true },
  { title: 'Solic.', field: 'requestedQuantity', disableOrder: true },
  { title: 'Retir.', field: 'withdraws-length', disableOrder: true },
])
const tableControl = ref({
  page: 1,
  total: item.value.items?.length,
  limit: item.value.items?.length,
  pages: 0,
  order: 'asc',
})
const getWithdraws = (withdraws, index) => {
  let totalWithdraw = 0
  if (withdraws && withdraws.length) {
    for (const withdraw of withdraws) {
      totalWithdraw += withdraw.quantity
    }
    return totalWithdraw
  }
  return 0
}
</script>
